import axios from 'axios';

const RESOURCE_API_URL = '/api/resources';
const RESERVATION_API_URL = '/api/reservations';

const buildHeaders = (token, comCode, contentType) => {
  const headers = { Authorization: `Bearer ${token}` };
  if (comCode) headers['x-com-code'] = comCode;
  if (contentType) headers['Content-Type'] = contentType;
  return headers;
};

/* -------------------- 자원(Resource) API -------------------- */

/** 자원 등록 (관리자만) */
export const createResource = async (data, token, comCode) => {
  const response = await axios.post(RESOURCE_API_URL, data, {
    headers: buildHeaders(token, comCode, 'application/json')
  });
  return response.data;
};

/** 자원 전체 조회 */
export const getResources = async (token, comCode) => {
  const response = await axios.get(RESOURCE_API_URL, {
    headers: buildHeaders(token, comCode)
  });
  return response.data;
};

/** 자원 단건 조회 */
export const getResourceById = async (id, token, comCode) => {
  const response = await axios.get(`${RESOURCE_API_URL}/${id}`, {
    headers: buildHeaders(token, comCode)
  });
  return response.data;
};

/** 자원 수정 */
export const updateResource = async (id, data, token, comCode) => {
  const response = await axios.put(`${RESOURCE_API_URL}/${id}`, data, {
    headers: buildHeaders(token, comCode, 'application/json')
  });
  return response.data;
};

/** 자원 삭제 */
export const deleteResource = async (id, token, comCode) => {
  const response = await axios.delete(`${RESOURCE_API_URL}/${id}`, {
    headers: buildHeaders(token, comCode)
  });
  return response.data;
};

/** 자원 등록/수정 시 클라이언트 검증 */
export const validateResource = (payload) => {
  const { res_type, res_category, parent_id, res_name, res_color, sort_order, use_yn, admin_id } = payload;

  console.log("===>" + admin_id)

  if (res_type === "카테고리") {
    if (!res_name) return "자원명을 입력하세요";
    if (!sort_order) return "정렬순서를 입력하세요";
    if (!use_yn) return "사용여부를 선택하세요";
  } else {
    if (!res_category) return "자원구분을 선택하세요";
    if (!parent_id) return "상위분류를 선택하세요";
    if (!res_name) return "자원명을 입력하세요";
    if (!res_color) return "색상을 선택하세요";
    if (!sort_order) return "정렬순서를 입력하세요";
    if (!use_yn) return "사용여부를 선택하세요";
    if (!admin_id) return "관리자를 선택하세요";
  }
  return null;
};


/* -------------------- 자원예약(Reservation) API -------------------- */
/** 예약 등록 */
export const createReservation = async (reservationData, token) => {
  
  //const reservationJson = JSON.stringify(reservationData);
  //console.log(reservationJson);

  try {
    const response = await axios.post(RESERVATION_API_URL, reservationData, {
      headers: { 
        Authorization: `Bearer ${token}`, 
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    // Axios 에러 그대로 throw → handleSubmit에서 err.response 접근 가능
    throw error;
  }
};

/** 예약 수정 */
export const updateReservation = async (id, data, token) => {
  const response = await axios.put(`${RESERVATION_API_URL}/${id}`, data, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
  });
  return response.data;
};

/**중복확인 */
export const checkOverlap = async (payload) => {
  const response = await axios.post(`${RESERVATION_API_URL}/checkOverlap`, payload);
  return response.data;
};

/** 예약 삭제 */
export const deleteReservation = async (id, token) => {
  const response = await axios.delete(`${RESERVATION_API_URL}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 예약 승인 */
export const approveReservation = async (id, token) => {
  //console.log("approveReservation 호출됨: id=", id);
  const response = await axios.post(`${RESERVATION_API_URL}/${id}/approve`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 예약 반려 (반려 사유 포함) */
export const rejectReservation = async (id, reason, token) => {
  //console.log(id, reason);

  const response = await axios.post(`${RESERVATION_API_URL}/${id}/reject`, 
    { rejectReason: reason }, 
    {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
    }
  );
  return response.data;
};

/** 예약 단건 조회 */
export const getReservationById = async (id, token) => {
  const response = await axios.get(`${RESERVATION_API_URL}/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

/** 예약 조회 - Calendar(viewtype 기반) */
export const getReservations = async (viewtype, params, token) => {

  //console.log("getReservations 호출됨: viewtype=", viewtype, ", params=", params);
  //console.log("토큰=", token);
  const response = await axios.get(`${RESERVATION_API_URL}/calendar`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { viewtype, ...params }
  });
  //console.log("data length =", response.data.length);
  return response.data;
};

/** 예약 조회 - List(status 기반) */
export const getReservationList = async (params, token) => {
   //console.log("getReservationList 호출됨: params=", params);
  const response = await axios.get(`${RESERVATION_API_URL}/list`, {
    headers: { Authorization: `Bearer ${token}` },
    params
  });

  return response.data;
};

/** 자원 목록 조회 (예약용) */
export const getReservationResources = async (token) => {
  const response = await axios.get(`${RESERVATION_API_URL}/resources`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};
